import { ViewTripHeader } from '@com-delta-idp/mnx-capability-trip-management-ui';
import { MyTripAem } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { UPC_SYS_ERR } from '../models/enums/my-trip.enums';
import {
  Errors,
  TripDetails
} from '../models/interface/my-trip-static.interface';
import {
  CarTripModel,
  FlightTripModel,
  MostUpcomingTrip,
  VacationTripModel
} from '../models/interface/upcoming-trip.interface';

export const adaptContent = (
  tripDetails: MostUpcomingTrip,
  staticContent: MyTripAem
): ViewTripHeader => {
  if (tripDetails?.carTrip) {
    return adaptCarTrip(tripDetails.carTrip, staticContent.tripDetails);
  }
  if (tripDetails?.trip) {
    return adaptFlightTrip(tripDetails.trip, staticContent);
  }
  if (tripDetails?.vacationTrip) {
    return adaptVacationTrip(tripDetails.vacationTrip, staticContent);
  }
  throw new Error(UPC_SYS_ERR);
};

export const adaptCarTrip = (
  carTrip: CarTripModel,
  tripContent: TripDetails
): ViewTripHeader => {
  return {
    title: tripContent?.carReservationTitle,
    location: {
      primary: carTrip.pickupCity,
      secondary: carTrip.vendorName
    },
    firstName: carTrip.firstName,
    lastName: carTrip.lastName,
    dateRange: carTrip.dateRange,
    viewDetailsLink: carTrip.detailsLink,
    content: {
      viewTripDetailsTitle: tripContent?.viewTripDetails
    }
  };
};

export const adaptFlightTrip = (
  trip: FlightTripModel,
  staticContent: MyTripAem
): ViewTripHeader => {
  return {
    title: staticContent.tripDetails?.upComingTripTitle,
    confirmationNo: trip.pnrNbr,
    location: {
      primary: trip.destinationCity
    },
    dateRange: trip.dateRange,
    checkinStatus: {
      isEligible: !!trip.checkinLink,
      isCheckedIn: trip.checkedIn,
      checkinLink: trip.checkinLink,
      departureAirport: trip.departureAirport
    },
    irop: {
      hasMessage: trip.iropImpact,
      message: trip.iropImpact
        ? adaptErrorMessage(staticContent.errors)?.[
            trip.iropMessage || 'IROP_EXC'
          ]?.description
        : undefined
    },
    firstName: trip.firstName,
    lastName: trip.lastName,
    viewDetailsLink: trip.detailsLink,
    content: {
      viewTripDetailsTitle: staticContent.tripDetails?.viewTripDetails,
      checkInTitle: staticContent.tripDetails?.checkIn,
      viewBoardingPassTitle: staticContent.tripDetails?.viewBoardingPass
    }
  };
};

export const adaptVacationTrip = (
  vacationTrip: VacationTripModel,
  staticContent: MyTripAem
): ViewTripHeader => {
  return {
    title: staticContent.tripDetails?.deltaVacationTitle,
    confirmationNo: vacationTrip.vacationConfirmationNbr,
    location: {
      primary: vacationTrip.destinationCityName
    },
    dateRange: vacationTrip.dateRange,
    checkinStatus: {
      isEligible: !!vacationTrip.checkinLink,
      isCheckedIn: vacationTrip.checkedIn,
      checkinLink: vacationTrip.checkinLink,
      departureAirport: vacationTrip.departureAirport
    },
    irop: {
      hasMessage: vacationTrip.iropImpact,
      message: vacationTrip.iropImpact
        ? adaptErrorMessage(staticContent.errors)?.[
            vacationTrip.iropMessage || 'IROP_EXC'
          ]?.description
        : undefined
    },
    firstName: vacationTrip.firstName,
    lastName: vacationTrip.lastName,
    viewDetailsLink: vacationTrip.detailsLink,
    content: {
      viewTripDetailsTitle: staticContent.tripDetails?.viewTripDetails,
      checkInTitle: staticContent.tripDetails?.checkIn,
      viewBoardingPassTitle: staticContent.tripDetails?.viewBoardingPass
    }
  };
};

export const adaptErrorMessage = (errorMessages: Errors[]) => {
  const errors: { [key: string]: { title: string; description: string } } = {};
  errorMessages?.forEach((errorMessage) => {
    errors[errorMessage.errorId] = {
      title: errorMessage.errorMessageTitle,
      description: errorMessage.errorMessageDescription
    };
  });
  return errors;
};
